import {Nut_Capabilities} from 'nutshell-core/settings-constants';

import {CTABanner} from 'shells/cta-banner/cta-banner';
import {TargetRegularIcon} from 'shells/icon/svg/target-regular-icon';

import {appHistory} from '../../../history';
import {useDismissibleUserSetting} from '../../../util/hooks/use-dismissible-user-setting';

import {useGetSessionUser} from '../../core/use-get-session-user';
import {useGetSetting} from '../../core/use-get-setting';

export function QuotasViaReportsCtaBanner() {
    const {user} = useGetSessionUser();
    const {shouldShow, onDismiss} = useDismissibleUserSetting('cuehide_quotas_via_reports_cta');

    const {setting: wasMigratedToQuotasV2} = useGetSetting({
        settingName: Nut_Capabilities.SETTING_HAS_MIGRATED_TO_QUOTAS_V2,
    } as const);

    if (
        shouldShow &&
        user &&
        user.permissions.canAccessSetup &&
        wasMigratedToQuotasV2?.value != null
    ) {
        return (
            <div className='px-16 pb-16'>
                <CTABanner
                    icon={TargetRegularIcon}
                    title="We've updated sales quotas!"
                    text='Instead of team-wide quotas, you can now assign targets directly to each user for more flexibility and control.'
                    buttonText='See for yourself'
                    onPrimaryAction={() => {
                        appHistory.push('/sales/sales-quotas');
                    }}
                    onDismiss={onDismiss}
                />
            </div>
        );
    }

    return null;
}
